import React, { useEffect, useState } from 'react';
import { Row, Col, message } from 'antd';
import { AuditOutlined } from '@ant-design/icons';
import { Button as MuiButton } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import YFTextArea from '../elements/YFTextArea';
import { submitEmployeeInfo } from '../../api';
import useApplicationSession from '../../session/UserSession';
import profileStore from './profileStore';

const EmployeeForm = ({ value }) => {
    const { register, handleSubmit, errors, setValue, setError } = useForm();
    const [isEdit] = useState(true);
    const token = useApplicationSession();
    const onSubmit = (data) => {
        if (isEdit) {
            const hideLoading = message.loading('Loading ...');
            submitEmployeeInfo({ token: token, request: data })
                .then((response) => {
                    hideLoading();
                    message.success(response.message);
                    profileStore.reload(token);
                })
                .catch((error) => {
                    if (error.errors) {
                        const nameArr = Object.keys(error.errors);
                        nameArr.forEach((key) => setError(key, 'required', error.errors[key][0]));
                    }
                });
        }
    };

    useEffect(() => {
        if (value !== null) {
            const values = [];
            const keys = Object.keys(value);
            keys.forEach((key) => {
                values.push({ [key]: value[key] });
            });
            setValue(values);
        }
    }, [value, setValue]);

    return (
        <form className="payment-information-form" onSubmit={handleSubmit(onSubmit)}>
            {/* -------- emploee info start --------*/}
            <div className="payment-information-label-container">
                <AuditOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                <h4 className="payment-information-label">Employment History</h4>
            </div>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="employer_name"
                        type="text"
                        label="Employer Name"
                        placeholder="Enter Employer Name"
                        register={register({
                            required: true,
                            minLength: { value: 3, message: 'Name of length must be greater than 3.' },
                        })}
                    />
                    <div className="form-error">
                        {errors.employer_name?.type === 'required' && (
                            <span className="formFieldError">Please enter employer name.</span>
                        )}
                        {errors.employer_name?.type === 'minLength' && (
                            <span className="formFieldError">{errors.employer_name.message}</span>
                        )}
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="occupation_position"
                        type="text"
                        label="Occupation/Position"
                        placeholder="Enter occupation/position"
                        register={register({
                            required: true,
                            minLength: { value: 3, message: 'Name of length must be greater than 3.' },
                        })}
                    />
                    <div className="form-error">
                        {errors.occupation_position?.type === 'required' && (
                            <span className="formFieldError">Please enter your occupation/position.</span>
                        )}
                        {errors.occupation_position?.type === 'minLength' && (
                            <span className="formFieldError">{errors.occupation_position.message}</span>
                        )}
                    </div>
                </Col>
            </Row>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="monthly_income"
                        type="number"
                        label="Current Salary (Monthly/Aunnual)"
                        placeholder="Enter Salary"
                        register={register({ required: true, maxLength: 15 })}
                    />
                    <div className="form-error">
                        {errors.monthly_income && <span className="formFieldError">Please enter monthly income.</span>}
                        {errors.monthly_income?.type === 'maxLength' && (
                            <span className="formFieldError">Invalid income rate.</span>
                        )}
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="length_of_employment"
                        type="text"
                        label="Length of Employement"
                        placeholder="Enter Length of Employement"
                        register={register({ required: true })}
                    />
                    <div className="form-error">
                        {errors.length_of_employment && (
                            <span className="formFieldError">Please enter your employement length.</span>
                        )}
                    </div>
                </Col>
            </Row>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="industry"
                        type="text"
                        label="Industry(e.g. Banking, legal, medical, etc.)"
                        placeholder="Enter Industry"
                        register={register({ required: true, minLength: 2, maxLength: 50 })}
                    />
                    <div className="form-error">
                        {errors.industry?.type === 'required' && (
                            <span className="formFieldError"> Please enter industry. </span>
                        )}
                        {errors.industry?.type === 'minLength' && (
                            <span className="formFieldError">Industry must be minimun 2 character.</span>
                        )}
                        {errors.industry?.type === 'maxLength' && (
                            <span className="formFieldError">Industry must be maximun 50 character.</span>
                        )}
                    </div>
                </Col>
            </Row>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container"
                >
                    <YFTextArea
                        disabled={isEdit}
                        name="address"
                        type="text"
                        label="Employer Address"
                        placeholder="Enter Employer Address"
                        rows={8}
                        register={register({ required: true, minLength: 3 })}
                    />
                    <div className="form-error">
                        {errors.address?.type === 'required' && (
                            <span className="formFieldError">Please enter your employer address.</span>
                        )}
                        {errors.address?.type === 'minLength' && (
                            <span className="formFieldError">Length of character must be at least 3.</span>
                        )}
                    </div>
                </Col>
            </Row>
            {/* -------- emploee info end --------*/}

            {/* -------- approval person start --------*/}
            <div className="payment-information-label-container">
                <AuditOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                <h4 className="payment-information-label">Approval Person</h4>
            </div>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="manager_name"
                        type="text"
                        label="Manager Name"
                        placeholder="Enter Manager Name"
                        register={register({ required: true, minLength: 3 })}
                    />
                    <div className="form-error">
                        {errors.manager_name?.type === 'required' && (
                            <span className="formFieldError">Please enter manager name.</span>
                        )}

                        {errors.manager_name?.type === 'minLength' && (
                            <span className="formFieldError">Length of character must be at least 3.</span>
                        )}
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="manager_email"
                        type="text"
                        label="Manager Email"
                        placeholder="Enter Manager Email"
                        register={register({
                            required: true,
                            pattern:
                                /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        })}
                    />
                    <div className="form-error">
                        {errors.manager_email?.type === 'required' && (
                            <span className="formFieldError">Please enter manager email.</span>
                        )}
                        {errors.manager_email?.type === 'pattern' && (
                            <span className="formFieldError">Please enter valid email format.</span>
                        )}
                    </div>
                </Col>
            </Row>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="manager_contact_number"
                        type="number"
                        label="Manager Phone"
                        placeholder="Enter manager phone"
                        register={register({ required: true })}
                    />
                    <div className="form-error">
                        {errors.manager_contact_number && (
                            <span className="formFieldError">Please enter manager contact detail.</span>
                        )}
                    </div>
                </Col>
            </Row>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container"
                >
                    <YFTextArea
                        disabled={isEdit}
                        name="manager_address"
                        type="text"
                        label="Manager Address"
                        placeholder="Enter Manager Address"
                        rows={8}
                        register={register({ required: true, minLength: 3 })}
                    />
                    <div className="form-error">
                        {errors.manager_address?.type === 'required' && (
                            <span className="formFieldError">Please enter manager address.</span>
                        )}
                        {errors.manager_address?.type === 'minLength' && (
                            <span className="formFieldError">Length of character must be 3 at least.</span>
                        )}
                    </div>
                </Col>
            </Row>
            {/* -------- approval person end --------*/}

            {/* -------- pervious work start --------*/}
            <div className="payment-information-label-container">
                <AuditOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                <h4 className="payment-information-label">Previous Work</h4>
            </div>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="previous_employer_name"
                        type="text"
                        label="Previous Employer Name"
                        placeholder="Enter previous employer name"
                        register={register({
                            required: false,
                            minLength: { value: 3, message: 'Number of character must be 3.' },
                        })}
                    />
                    <div className="form-error">
                        {errors.previous_employer_name?.type === 'required' && (
                            <span className="formFieldError">Please enter pervious employer name.</span>
                        )}
                        {errors.previous_employer_name?.type === 'minLength' && (
                            <span className="formFieldError">{errors.previous_employer_name.message}</span>
                        )}
                    </div>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="previous_occupation_position"
                        type="text"
                        label="Previous occupation/position"
                        placeholder="Enter occupation/position"
                        register={register({ required: false, minLength: 3 })}
                    />
                    <div className="form-error">
                        {errors.previous_occupation_position?.type === 'required' && (
                            <span className="formFieldError"> Please enter previous occupation/position. </span>
                        )}
                        {errors.previous_occupation_position?.type === 'minLength' && (
                            <span className="formFieldError">Length of character must be at least 3.</span>
                        )}
                    </div>
                </Col>
            </Row>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container"
                >
                    <YFTextArea
                        disabled={isEdit}
                        name="previous_address"
                        type="text"
                        label="Previous Manager Address"
                        placeholder="Enter Prvious Employer Address"
                        rows={8}
                        register={register({ required: false, minLength: 3 })}
                    />
                    <div className="form-error">
                        {errors.previous_address?.type === 'required' && (
                            <span className="formFieldError">Please enter employer address.</span>
                        )}
                        {errors.previous_address?.type === 'minLength' && (
                            <span className="formFieldError">Length of character must be at least 3.</span>
                        )}
                    </div>
                </Col>
            </Row>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={isEdit}
                        name="previous_length_of_employment"
                        type="text"
                        label="Previous length of employement"
                        placeholder="Enter length of employement"
                        register={register({ required: false })}
                    />
                    <div className="form-error">
                        {errors.previous_length_of_employement?.type === 'required' && (
                            <span className="formFieldError">Please enter length of employement.</span>
                        )}
                    </div>
                </Col>
            </Row>
            {/* -------- pervious work end --------*/}

            <MuiButton className="secondary-btn profileNext" type="submit">
                save
            </MuiButton>
            {/* <MuiButton onClick={() => onPrevious()} className="secondary-btn profileNext">back</MuiButton> */}
        </form>
    );
};

EmployeeForm.propTypes = {
    // next: PropTypes.func.isRequired,
    // previous: PropTypes.func.isRequired,
};

export default EmployeeForm;
